export default {
  ListView: {
    Title: 'Staff | Staff | Staff',

    Button: {
      StaffAdd: {
        Title: 'Staff',
        Color: 'primary',
        Icon : 'add_box'
      },
      StaffGroups: {
        Title: 'Staff Groups',
        Color: 'indigo',
        Icon : 'group'
      }
    },

    Table: {
      Button: {
        Edit: {
          Title: 'Edit',
          Color: 'cyan',
          Icon : 'edit'
        }
      },
      Headers: {
        Id            : '#',
        Firstname     : 'Firstname',
        Lastname      : 'Lastname',
        Email         : 'E-mail',
        Domain        : 'Domain',
        GroupName     : 'Group',
        HasPermissions: 'Permissions',
        Locale        : 'Language',
        LocaleCatalog : 'Catalog Language',
        SingleLogin   : 'Single Login',
        Guest         : 'Guest',
        Status        : 'Status',
        DateAdded     : 'Date Added',
        Actions       : ''
      }
    }
  },
  StaffAddDialog: {
    Add: {
      Title   : 'Add Staff',
      Subtitle: 'Create New Staff',
      Color   : 'indigo',
      Icon    : 'supervisor_account'
    },
    Edit: {
      Title   : 'Edit Staff',
      Subtitle: 'Edit Staff Details',
      Color   : 'indigo',
      Icon    : 'supervisor_account'
    },
    Tab: {
      Info       : 'Info',
      Permissions: 'Permissions'
    },
    Field: {
      Firstname: {
        Label: 'First Name',
        Hint : 'Staff\'s First Name. eg. George, Jane, etc.',
        Icon : 'account_circle',
        Error: {
          Between: 'First Name must be between 2 and 32 characters.'
        }
      },
      Lastname: {
        Label: 'Last Name',
        Hint : 'Staff\'s Last Name. eg. Smith, Doe, etc.',
        Icon : 'account_circle',
        Error: {
          Between: 'Last Name must be between 2 and 32 characters.'
        }
      },
      Telephone: {
        Label: 'Telephone',
        Hint : 'Staff\'s Mobile or Landline. eg. 2106105200',
        Icon : 'phone',
        Error: {
          Between: 'Telephone number must be between 8 and 16 digits'
        }
      },
      Email: {
        Label: 'Email',
        Hint : 'Staff\'s Email. eg. support@getfoodpro.gr',
        Icon : 'email',
        Error: {
          Between: 'E-mail must be up to 96 characters long',
          Valid  : 'E-mail must be valid'
        }
      },
      GroupId: {
        Label: 'Staff Group',
        Hint : 'Staff Group. eg. Administrator, User',
        Icon : 'group',
        Error: 'Field is required'
      },
      Pin: {
        Label: 'PIN',
        Hint : 'Staff\'s PIN number eg. 1234',
        Icon : 'fiber_pin',
        Error: {
          FixedNumber: 'PIN must be 4 digits long'
        }
      },
      Locale: {
        Label: 'System Language',
        Hint : 'Select the language you want the system to be displayed',
        Icon : 'language'
      },
      Domain: {
        Label: 'Domain',
        Icon : 'http',
        Error: 'Field is required'
      },
      Group: {
        Label: 'Group',
        Icon : 'group_work',
        Error: ''
      },
      VoipDomain: {
        Label: 'VoipDomain',
        Icon : 'phonelink_setup',
        Error: ''
      },
      VoipAgent: {
        Label: 'VoipAgent',
        Icon : 'contact_phone',
        Error: ''
      },
      Status: {
        Title: 'Status'
      },
      Guest: {
        Title: 'Guest Login'
      }
    },

    Settings: {
      PosTransactionManualAccept: {
        Title   : 'Manual Transaction Approval',
        Subtitle: 'Manual EFT/POS Transaction Approval'
      },

      PosTransactionManualAcceptAllStates: {
        Title   : 'Manual Transaction Approval for All States',
        Subtitle: 'Manual EFT/POS Transaction Approval for All States'
      },

      PosTransactionManualAcceptRevert: {
        Title   : 'Revert Manual Transaction Approval',
        Subtitle: 'Revert Manual EFT/POS Transaction Approval'
      },

      ActivePaymentTypes: {
        Title   : 'Custom Active Payment Types',
        Subtitle: 'Customise the payment methods available to the User'
      },

      ActivePrintMachineGroups: {
        Title   : 'Custom Work Stations for Printing',
        Subtitle: 'Customise the work stations for printing'
      },

      ActiveEftPos: {
        Title   : 'Custom Active EFT/POS Terminals',
        Subtitle: 'Customise the EFT/POS Terminals available to the User'
      },

      CanDeleteOrder: {
        Title   : 'Delete Orders',
        Subtitle: 'Allow deletion of orders'
      },

      CanAddOrderDiscount: {
        Title   : 'Add Predefined Discount',
        Subtitle: 'Add predefined discount to product, order or table'
      },
      CanAddOrderDiscountCustom: {
        Title   : 'Add Custom Discount',
        Subtitle: 'Add custom discount to product, order or table'
      },

      Catalog: {
        Title : 'Products Catalog',
        Icon  : 'menu_book',
        Select: {
          Label: 'Available Catalogs',
          Hint : 'Select catalogs available to the user'
        },
        Default: {
          Label: 'Default Catalog',
          Hint : 'Select default catalog'
        }
      },

      Product: {
        Title: 'Products',
        Icon : 'mdi-cart-plus'
      },
      CanCopyProductOptions: {
        Title   : 'Copy Product Options',
        Subtitle: 'Allow copying of product options'
      },

      Print: {
        Title: 'Printing',
        Icon : 'mdi-printer'
      },
      CanPrintOrderDocument: {
        Title   : 'Print Order Document',
        Subtitle: 'Allow printing of order documents'
      },
      CanPrintOrderPreparation: {
        Title   : 'Print Order Preparation Document',
        Subtitle: 'Allow printing of order preparation documents'
      },
      CanPrintOrderFiscal: {
        Title   : 'Print Fiscal Document',
        Subtitle: 'Allow printing of fiscal documents'
      },
      CanPrintReportZ: {
        Title   : 'Print Sales Fiscal Doc Report (Z)',
        Subtitle: 'Allow printing of Sales Fiscal Doc Report (Z)'
      },
      CanPrintMarketing: {
        Title   : 'Print Marketing Document',
        Subtitle: 'Allow printing of marketing documents'
      },
      CanPrintDeliveryShift: {
        Title   : 'Print Delivery Staff Shift Report',
        Subtitle: 'Allow printing of delivery staff shift reports'
      },
      CanPrintWaiterShift: {
        Title   : 'Print Waiter Shift Report',
        Subtitle: 'Allow printing of waiter shift reports'
      }
    }
  },

  StaffGroups: {
    Misc: {
      User       : 'Users | User | Users',
      ChooseGroup: {
        Title   : 'Choose staff group',
        Subtitle: 'Choose staff group from the list',
        Icon    : 'group'
      },
      ChoosePackage: 'Choose Plan'
    },
    Groups: {
      Title         : 'Staff Groups',
      Subtitle      : 'Access rights',
      Color         : 'indigo',
      Icon          : 'group',
      ModulesPackage: 'Modules / Package'
    },
    SingleGroup: {
      Subtitle: 'Access rights',
      Color   : 'blue',
      Icon    : 'group_work',
      Headers : {
        Right : 'Right',
        Access: 'Access',
        Api   : 'Api',
        Edit  : 'Edit',
        Add   : 'Add',
        Delete: 'Delete'
      }
    }

  }
}
